import React from 'react';
import { IconProps } from './types';

export function DeleteIcon(props: IconProps) {
	const { width, height, stroke } = props;

	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 17 18"
			fill="none"
		>
			<path
				d="M16 4.18394C13.225 3.91994 10.4333 3.78394 7.65 3.78394C6 3.78394 4.35 3.86394 2.7 4.02394L1 4.18394"
				stroke={stroke}
				strokeWidth="1.15"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M5.58325 3.376L5.76659 2.328C5.89992 1.568 5.99992 1 7.40825 1H9.59159C10.9999 1 11.1083 1.6 11.2333 2.336L11.4166 3.376"
				stroke={stroke}
				strokeWidth="1.15"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M14.2084 6.71204L13.6667 14.768C13.5751 16.024 13.5001 17 11.1751 17H5.82508C3.50008 17 3.42508 16.024 3.33341 14.768L2.79175 6.71204"
				stroke={stroke}
				strokeWidth="1.15"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M7.1084 12.6001H9.8834"
				stroke={stroke}
				strokeWidth="1.15"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M6.4165 9.3999H10.5832"
				stroke={stroke}
				strokeWidth="1.15"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
